"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _opentokReact = require("opentok-react");
var _react = _interopRequireWildcard(require("react"));
var _ = require("../..");
var _utils = require("../../../utils");
var _components = require("../../../components");
var _constants = require("../constants");
var _Video = require("./Video");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var isCompanionConnectionOK = function isCompanionConnectionOK(lastSeen) {
  if (!lastSeen) {
    return null;
  }
  var currentTime = Date.now();
  var timeDelta = currentTime - lastSeen;
  return timeDelta < _constants.VIDEO_SIGNAL_INTERVAL * 2.5;
};
var isCompanionDestroyed = function isCompanionDestroyed(lastSeen) {
  if (!lastSeen) {
    return null;
  }
  var currentTime = Date.now();
  var timeDelta = currentTime - lastSeen;
  return timeDelta > _constants.MAX_DISCONNECTION_TIME;
};
var useCompanionAliveCheck = function useCompanionAliveCheck(connectionId, message, setSubscriber, subscriber, targetName, updateMessage, onFinish) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    lastSeen = _useState2[0],
    setLastSeen = _useState2[1];
  (0, _react.useEffect)(function () {
    if (subscriber) {
      setSubscriber(subscriber);
      var session = subscriber.session;
      if (window.signalInterval) {
        clearInterval(window.signalInterval);
      }
      window.signalInterval = setInterval(function () {
        if (session && session.currentState === 'connected') {
          session.signal({
            type: 'alive',
            retryAfterReconnect: false
          });
        }
      }, _constants.VIDEO_SIGNAL_INTERVAL);
      session.on('signal:alive', function (event) {
        if (event.from.id !== connectionId) {
          setLastSeen(Date.now());
        }
      });
    }
    return function () {
      clearInterval(window.signalInterval);
      setSubscriber(null);
    };
  }, [connectionId, subscriber]);
  var isCompanionConnected = isCompanionConnectionOK(lastSeen);
  var isCompanionGone = isCompanionDestroyed(lastSeen);
  (0, _react.useEffect)(function () {
    var _subscriber$session;
    if ((0, _lodash.isBoolean)(isCompanionGone) && !isCompanionConnected && isCompanionGone && subscriber !== null && subscriber !== void 0 && subscriber.session) {
      updateMessage(_constants.MESSAGES.SUBSCRIBER_DESTROYED(targetName));
      onFinish();
    } else if ((0, _lodash.isBoolean)(isCompanionConnected) && !isCompanionConnected && !message && message !== _constants.MESSAGES.SUBSCRIBER_DESTROYED(targetName) && (subscriber === null || subscriber === void 0 ? void 0 : (_subscriber$session = subscriber.session) === null || _subscriber$session === void 0 ? void 0 : _subscriber$session.currentState) === 'connected') {
      updateMessage(_constants.MESSAGES.SUBSCRIBER_DISCONNECTED(targetName));
    } else if (isCompanionConnected && message === _constants.MESSAGES.SUBSCRIBER_DISCONNECTED(targetName)) {
      updateMessage(_constants.MESSAGES.SUBSCRIBER_CONNECTED(targetName), _constants.MESSAGE_TIMEOUT);
    }
  }, [isCompanionConnected, targetName, updateMessage, isCompanionGone]);
  var onConnect = (0, _react.useCallback)(function (event) {
    setSubscriber(event === null || event === void 0 ? void 0 : event.target);
    setLastSeen(Date.now() + _constants.VIDEO_SIGNAL_INTERVAL);
  }, []);
  var onDisconnect = (0, _react.useCallback)(function () {
    setSubscriber(null);
  }, []);
  return {
    onConnect: onConnect,
    onDisconnect: onDisconnect
  };
};
var Subscriber = function Subscriber(_ref) {
  var connectionId = _ref.connectionId,
    connectionStatus = _ref.connectionStatus,
    isSubscriberVideoEnabled = _ref.isSubscriberVideoEnabled,
    isSubscriberScreenSharingEnabled = _ref.isSubscriberScreenSharingEnabled,
    message = _ref.message,
    onConnectionStatusChange = _ref.onConnectionStatusChange,
    onError = _ref.onError,
    onFinish = _ref.onFinish,
    onSubscribe = _ref.onSubscribe,
    setIsSubscriberVideoEnabled = _ref.setIsSubscriberVideoEnabled,
    setSubscriber = _ref.setSubscriber,
    subscriber = _ref.subscriber,
    targetAvatarImage = _ref.targetAvatarImage,
    targetName = _ref.targetName,
    updateMessage = _ref.updateMessage;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useCompanionAliveChe = useCompanionAliveCheck(connectionId, message, setSubscriber, subscriber, targetName, updateMessage, onFinish),
    onConnect = _useCompanionAliveChe.onConnect,
    onDisconnect = _useCompanionAliveChe.onDisconnect;
  var _useCssMedia = (0, _utils.useCssMedia)(),
    md = _useCssMedia.md;
  var subscriberEventHandlers = {
    connected: function connected(e) {
      var _e$target, _e$target$stream, _e$target2, _e$target2$stream;
      var connectedUserName = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$stream = _e$target.stream) === null || _e$target$stream === void 0 ? void 0 : _e$target$stream.name;
      var isCompanionConnected = !!connectedUserName && connectedUserName !== user.nickName;

      // in the majority of cases isCompanionConnected will be true but the possible edge case
      // is when current user connects from the another device/tab when current session is active
      // backend is responsible to disconnect previous connection but connection from another device/tab
      // will still "see" previous connection for a moment an we do not want it to be considered as
      // companion connected
      if (!isCompanionConnected) {
        return;
      }
      onConnect(e);
      onSubscribe();
      onConnectionStatusChange(_utils.SessionEvents.Connected);
      setIsSubscriberVideoEnabled((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$stream = _e$target2.stream) === null || _e$target2$stream === void 0 ? void 0 : _e$target2$stream.hasVideo);
      window.dispatchEvent(new Event(_utils.VIDEO_CHAT_EVENTS.RESIZE));
      if (message === _constants.MESSAGES.SUBSCRIBER_DISCONNECTED(targetName)) {
        updateMessage(_constants.MESSAGES.SUBSCRIBER_CONNECTED(targetName), _constants.MESSAGE_TIMEOUT);
      }
    },
    disconnected: function disconnected(e) {
      console.error('disconnected', e);
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('Subscriber disconnected', e);
      }
      setIsSubscriberVideoEnabled(false);
      onDisconnect();
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error("CONNECTION STATUS CHANGED TO ".concat(connectionStatus));
      }
      if ([_utils.SessionEvents.Connecting, _utils.SessionEvents.Disconnected, _utils.SessionEvents.Reconnecting].includes(connectionStatus)) {
        return;
      }
      updateMessage(_constants.MESSAGES.SUBSCRIBER_DISCONNECTED(targetName));
    },
    videoEnabled: function videoEnabled(e) {
      setIsSubscriberVideoEnabled(true);
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('videoEnabled', e);
      }
    },
    videoDisabled: function videoDisabled(e) {
      setIsSubscriberVideoEnabled(false);
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('videoDisabled', e);
      }
      if (e.reason === 'quality') {
        updateMessage(_constants.MESSAGES.SUBSCRIBER_VIDEO_QUALITY_LOW(), _constants.MESSAGE_TIMEOUT);
      }
    },
    audioBlocked: function audioBlocked(e) {
      // TODO: can be more user friendly message
      // const title = 'Your browser has blocked audio play for Monument, please allow it !';
      // toast.info({ title });
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('audioBlocked', e);
      }
    },
    audioUnblocked: function audioUnblocked(e) {
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('audioUnblocked', e);
      }
    },
    videoDimensionsChanged: function videoDimensionsChanged(e) {
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('videoDimensionsChanged', e);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "center",
    align: "middle",
    className: (0, _classnames.default)('video-subscriber-container', !isSubscriberVideoEnabled && !isSubscriberScreenSharingEnabled && 'subscriber-hidden', message && 'disconnected')
  }, /*#__PURE__*/_react.default.createElement(_opentokReact.OTStreams, null, /*#__PURE__*/_react.default.createElement(_opentokReact.OTSubscriber, {
    properties: {
      height: '100%',
      preferredFrameRate: (0, _utils.isMobile)() ? 15 : 30,
      preferredResolution: (0, _utils.isMobile)() ? '320x240' : '640x480',
      showControls: false,
      width: '100%'
    },
    onError: onError,
    eventHandlers: subscriberEventHandlers,
    retry: true,
    maxRetryAttempts: 3,
    retryAttemptTimeout: 2000
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('subscriber-placeholder', isSubscriberVideoEnabled || isSubscriberScreenSharingEnabled ? 'none' : 'absolute top-0 left-0 w-full h-full flex justify-center items-center')
  }, /*#__PURE__*/_react.default.createElement(_components.Avatar, {
    size: md ? 135 : 82,
    imageId: targetAvatarImage,
    name: targetName || '',
    shape: "circle",
    className: "rounded-full overflow-auto",
    isCdnImage: !!targetAvatarImage
  })));
};
var _default = Subscriber;
exports.default = _default;